import React from 'react';
import SectionKicker from './SectionKicker';
import ClickMark from './ClickMark';
import {IconCalendar,IconSend,IconLifeBuoy} from './Icons';

const steps=[
  {icon: IconCalendar,number: '01',title: 'Book a free call',text: 'Tell us how your business runs and where things slip through the cracks. We recommend only what will help.',color: '#caa1eb'},
  {icon: IconSend,number: '02',title: 'We set it up',text: 'We build and connect everything to your phone number, website and accounts, and test it with you.',color: '#f7a38c'},
  {icon: IconLifeBuoy,number: '03',title: 'We keep it running',text: 'We watch over it and make changes when you ask. You get one place to go for your tech.',color: '#94b6e8'}
];

function HowItWorks() {
  return (
    <section className="section process-section" id="how-it-works-steps">
      <div className="center-heading">
        <SectionKicker tone={2}>How it works</SectionKicker>
        <h2>Three steps.<br /><em>No tech work for you.</em></h2>
      </div>
      <div className="steps" style={{gridTemplateColumns: 'repeat(3,1fr)'}}>
        {steps.map(({icon: Icon,number,title,text,color})=> (
          <article className="step" key={number}>
            <div className="step-icon"><Icon /><span>{number}</span></div>
            <h3>{title}</h3>
            <p>{text}</p>
            <ClickMark className="step-mark" color={color} />
          </article>
        ))}
      </div>
      <p className="service-note">
        <a className="footer-link" href="#/how-it-works">See who does what</a>
      </p>
    </section>
  );
}

export default HowItWorks;
